import axios from 'axios'

export const BASE_URL = process.env.NODE_ENV == "production" ? process.env.BASE_URL : "http://localhost:3333/";

export const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
})

// Variable pour stocker l'instance du store
let authStore = null

// Fonction pour initialiser le store
export const initApiStore = (store) => {
    authStore = store
}

// Interceptor pour ajouter le token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('auth_token')
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => Promise.reject(error)
)

export const setAuthToken = (token) => {
    if (token) {
        localStorage.setItem('auth_token', token)
    } else {
        localStorage.removeItem('auth_token')
    }
}

export const getAuthToken = () => {
    return localStorage.getItem('auth_token')
}